import { render } from "./PipBanner.vue?vue&type=template&id=e15f9e18"
import script from "./PipBanner.vue?vue&type=script&lang=js"
export * from "./PipBanner.vue?vue&type=script&lang=js"

import "./PipBanner.vue?vue&type=style&index=0&id=e15f9e18&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__